<template>
<el-row>
  <headertop></headertop>
    <el-row class="all" v-show="showlocal || showpublic">
      <el-row class="allitem" v-show="showlocal">
           <p> 内部视频回看</p>
             <!-- 表格 -->
      <div style="overflow: auto;">
       <el-table :data="videolistlocal" style="width: 100% ;"
        :default-sort = "{prop: 'videolistlocal', order: 'descending'}"
            >
        <el-table-column
        prop="num"
        label="序号"
        sortable
       >
        </el-table-column>
        <el-table-column
         prop="name"
         label="视频名称"
         sortable
       >
       </el-table-column>
      <el-table-column
      fixed="right"
      label="操作"
      :formatter="formatter"
      >
      <template slot-scope="scope">
        <el-button
          @click.native.prevent="deleteRow(scope.$index,'local')"
          type="text"
          size="small">
          查看
        </el-button>
      </template>
    </el-table-column>
    </el-table>
    </div>
      </el-row>
       <el-row class="allitem" v-show="showpublic">
          <p>外部视频回看</p>
     <div style="overflow: auto;">
       <el-table :data="videolistpublic" style="width: 100% ;"
        :default-sort = "{prop: 'videolistpublic', order: 'descending'}"
            fit>
        <el-table-column
        prop="serial_number"
        label="序号"
        sortable
       >
        </el-table-column>
        <el-table-column
         prop="name"
         label="视频名称"
         sortable
       >
       </el-table-column>
      <el-table-column
      fixed="right"
      label="操作"
      :formatter="formatter"
      >
      <template slot-scope="scope">
        <el-button
          @click.native.prevent="deleteRow(scope.$index,'public')"
          type="text"
          size="small">
          查看
        </el-button>
      </template>
    </el-table-column>
    </el-table>
    </div>
       </el-row>
     </el-row>
    <!--文档-->
    <el-row class="all" v-show="showfile">
      <p>文档回看</p>
       <div style="overflow: auto;">
       <el-table :data="filelist" style="width: 100% ;"
        :default-sort = "{prop: 'filelist', order: 'descending'}"
            fit>
        <el-table-column
        prop="name"
        label="名字"
        sortable
       >
        </el-table-column>
        <el-table-column
         prop="time"
         label="时间"
         sortable
       >
       </el-table-column>
      <el-table-column
      fixed="right"
      label="操作"
      :formatter="formatter"
      >
      <template slot-scope="scope">
        <el-button
          @click.native.prevent="deleteRow(scope.$index,'file')"
          type="text"
          size="small">
          查看
        </el-button>
      </template>
    </el-table-column>
    </el-table>
    </div>
      </el-row>
      <!--卷子-->
    <el-row class="all" v-show="showexam">
      <p>考试回看</p>
       <div style="overflow: auto;">
       <el-table :data="examlist" style="width: 100% ;"
        :default-sort = "{prop: 'examlist', order: 'descending'}"
            fit>
        <el-table-column
        prop="num"
        label="序号"
        sortable
       >
        </el-table-column>
        <el-table-column
         prop="time"
         label="时间"
         sortable
       >
       </el-table-column>
      <el-table-column
      fixed="right"
      label="操作"
      :formatter="formatter"
      >
      <template slot-scope="scope">
        <el-button
          @click.native.prevent="deleteRow(scope.$index,'exam')"
          type="text"
          size="small">
          查看
        </el-button>
      </template>
    </el-table-column>
    </el-table>
    </div>
    </el-row>
    <!--线下-->
    <el-row class="xianxia" v-show="showxianxia">
       <p style=" display: flex; justify-content: center; align-items: center;">{{name}}</p>
       <div style="  padding-left: 7%;">
       <p>任务类型： {{type}}</p>
       <p>任务分类：{{t_id}}</p>
       <p>任务级别： {{name}}</p>
       <p>任务类型： {{type}}</p>
       <p>培训内容：{{content}}</p>
       <p>培训说明：{{info}}</p>
       <p>开始时间：{{start_time}}</p>
       <p>结束时间：{{end_time}}</p>
       </div>

    </el-row>
      <footerbom></footerbom>
</el-row>

</template>
<script>
  import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        //线下
        content:'',
        e_time:'',
        end_time:'',
        info:'',
        name:'',
        role_type:'',
        s_time:'',
        start_time:'',
        t_id:'',
        type:'',
        //视频文档
        showlocal:false,
        showpublic:false,
        showexam:false,
        showfile:false,
        showxianxia:false,
        reviewlist:{
          num:this.$route.query.num,
          type:this.$route.query.type,
        },
        examlist:[],//考试list
        filelist:[],//文档list
         //视频list
        videolistpublic:[],
        //视频list
        videolistlocal:[],
      }},
      components: {
      headertop: Header,
      footerbom: Footer
       },
      mounted: function (){
        this.get_task_info();
      },
      methods: {
       get_task_info() {
         let _this = this;
          _this.axios
        .get("/v2/user_task/get_train_info", {
          params: {num: _this.reviewlist.num , type: _this.reviewlist.type},
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              if( _this.reviewlist.type=='train'){
               if(res.data.data.video.local.length != 0){
               _this.videolistlocal=res.data.data.video.local
                _this.showlocal=true
              }
               if(res.data.data.video.public.length != 0){
               _this.videolistpublic=res.data.data.video.public
               _this.showpublic=true
              }
              if(res.data.data.exam.length != 0){
               _this.examlist=res.data.data.exam
               _this.showexam=true
              }
               if(res.data.data.file.length != 0){
                _this.filelist=res.data.data.file
                _this.showfile=true
              }
              }else{
                _this.showxianxia=true
                _this.content=res.data.data.content
                _this.e_time=res.data.data.e_time
                _this.end_time=res.data.data.end_time
                _this.info=res.data.data.info
                _this.role_type=res.data.data.role_type
                _this.name=res.data.data.name
                _this.s_time=res.data.data.s_time
                _this.start_time=res.data.data.start_time
                _this.type=res.data.data.type
                _this.t_id=res.data.data.t_id
              }

            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
    },

      formatter(row, column) {
      },
      deleteRow(index, type) {
        if(type=="public"){
         this.$router.push({path:'/courseplay',query:{num:this.videolistpublic[index].serial_number, type:1,resource:'v'}})
        }else if(type=="local"){
        this.$router.push({path:'/courseplay',query:{num:this.videolistlocal[index].num, type:0,resource:'v'}})
        }else if(type=="file"){
          alert(this.filelist);
        this.$router.push({path:'/FileQCregister',query:{num:this.filelist[index].num}})
        }else if(type=="exam"){
        this.$router.push({path:'/TasksubjeCtresult',query:{num:this.examlist[index].num}})
        }

      }
    }
}
</script>
<style scoped>
.all{
    width: 80%;
    background-color: white;
    margin-left: 10%;

    margin-top: 30px;
    border:  1px solid #dcdfe6;
    padding: 10px;
}
.allitem p{
    border-bottom: 1px solid #dcdfe6;
     padding-bottom: 10px;
     font-size: 20px;
     padding-left: 20px;

}
.allitem{
   width: 100%;
    background-color: white;
   padding: 10px;
    margin-top: 30px;
    border:  1px solid #dcdfe6;
}
.toubuleft{
    flex: 1;
}
.toubu{
 display:flex

}
  /* 分页 */
  .block {
    margin-left: 45%;
  }

  .certimg {
    width: 100%;
  }
  .xianxia{
     border:  1px solid #dcdfe6;
     width: 90%;
     background-color: white;
     height: 500px;
     margin-left:4%;
     margin-top: 5%;

  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/Task/Taskreview.vue